module.exports = __webpack_public_path__ + "static/media/addProductIcon.8a9dcf44.svg";